module.exports = __webpack_public_path__ + "img/Doner Kebab Icon - white.93a47727.svg";